export default __webpack_public_path__ + "static/media/pending.1be0dbac.svg";